import React, { useState, useEffect } from "react";

import DataRenderer from "../../common/dataRenderer";
import StatusComp from "../../common/StatusComp";

const PreTradeListComp = (props) => {

    //onst [listFrame, setListFrame] = useState(() => props.items.slice(props.dataFrame.startIndex, props.dataFrame.limit));
    const [listFrame, setListFrame] = useState([]);


    const handleShowMore = () => {

        if (props.dataFrame.limit <= listFrame.length) {
            var index = listFrame.length + props.dataFrame.limit;
            props.setDataFrame(p => { return { ...p, limit: index } })

        }

    }


    useEffect(() => {
        var index = listFrame.length;
        setListFrame(p => p.concat(props.items.slice(index, props.dataFrame.limit)));
    }, [props.dataFrame.limit]);



    return (
        <div className="m-list">
            <ul className="flex-table">
                <li className="table-row table-header">
                    <div className="table-data">
                        <div className="table-cell">Intended Trade Date</div>
                        <div className="table-cell">Security Type</div>
                        <div className="table-cell">Security Symbol</div>
                        {/* <div className="table-cell">Quantity</div> */}
                        <div className="table-cell">Security Description</div>
                        <div className="table-cell">Account</div>
                        {(localStorage.getItem("ENABLE_CREATE_ON_BEHALF")==='true') &&
                            <>
                            <div className="table-cell">Employee</div>
                            <div className="table-cell">Submitted By</div>
                            </>
                        }
                        <div className="table-cell">Trade Action</div>
                        <div className="table-cell">Request Status</div>
                    </div>
                </li>

                {props.items.map(item => {

                    return (
                        <li key={item.id} className="table-row clickable" onClick={p => props.onDetail(item)}>
                            <div className="table-data">
                                <div className="table-cell" data-title="Intended Trade Date : ">{item.tradeDate}</div>
                                <div className="table-cell" data-title="Security Type : ">{DataRenderer.renderSecurityType(item.securityType)}</div>
                                <div className="table-cell" data-title="Security Symbol : ">{item.securitySymbol}</div>
                                {/* <div className="table-cell" data-title="Quantity : ">{item.quantity}</div> */}
                                <div className="table-cell" data-title="Security Description : ">{item.securityDesc}</div>
                                <div className="table-cell" data-title="Account : ">{item.accountNumber}</div>
                                {(localStorage.getItem("ENABLE_CREATE_ON_BEHALF")==='true') &&
                                    <>
                                    <div className="table-cell" data-title="Employee : ">{item.employeeName}</div>
                                    <div className="table-cell" data-title="Submitted By : ">{item.submittedBy}</div>
                                    </>
                                }
                                <div className="table-cell" data-title="Trade Action : ">{DataRenderer.renderTradeAction(item.tradeAction)}</div>
                                <div className="table-cell" data-title="Request Status : "><StatusComp status={item.status}>{item.statusLabel}</StatusComp></div>
                            </div>
                            
                        </li>
                    )
                })
                }
            </ul>

            {/* <div className="flex list-footer">
                <div className="footer-message"><span className="label-light">Showing</span>  {listFrame.length} <span className="label-light">of</span> {props.items.length}</div>
                <button
                    id="btnGetProductList"
                    type="button"
                    className="btn btn-primary-outline"
                    onClick={handleShowMore}
                >Show More</button>
            </div>
             */}
        </div>
    );
}


export default PreTradeListComp;